import { DependencyUsage } from '@modules/Dependencies/api/models/dependency-usage.model';

export type ItemData = {
  itemName?: string,
  target: string,
  params: {
    itemType?: string,
    scriptType?: string | number,
    dataSource?: string,
    uri?: string
  }
}

const items: { [key: string]: ItemData } = {
  FlowDecision: {
    target: 'self',
    params: {
      itemType: 'Script',
    },
  },
  FlowVerification: {
    target: 'self',
    params: {
      itemType: 'Script',
      scriptType: 0
    }
  },
  ProcessFlowItem: {
    target: 'self',
    params: {
      itemType: 'Script',
      scriptType: 'Output'
    }
  },
  Gateway: {
    target: 'self',
    params: {
      itemType: 'Script',
      scriptType: 'ToId'
    }
  },
  Matrix: {
    target: 'self',
    params: {
      itemType: 'InputScript',
      scriptType: 'Script'
    }
  },
  Model: {
    target: 'blank',
    params: {
      uri: '#/models/browse/:itemName'
    }
  },
  Signal: {
    target: 'blank',
    params: {
      uri: '#/signals/edit/:itemName'
    }
  },
  DataProvider: {
    target: 'blank',
    params: {
      uri: '#/prototypes/edit/:runtimeName'
    }
  },
  Workflow: {
    target: 'blank',
    params: {
      uri: '#/workflows/edit/:workflowName/:version'
    }
  }
};

export function makeTransitionLinkParams(item: DependencyUsage) {
  const metadata: ItemData = items[item.ItemType];

  if (!metadata) { return null }

  if ( metadata.target === 'self' ) {
    return makeLinkSelfParams(item)
  } else {
   return makeLinkBlankParams(item);
  }
}

export function makeLinkSelfParams(item: DependencyUsage) {
  const itemData: ItemData = items[item.ItemType];

  if (!itemData) { return null }

  let params = { itemId: item.ItemId, ...itemData.params };

  switch (item.ItemType) {
      // scriptType
    case 'ProcessFlowItem':
      if (item.ScriptType === 'InputScript') {
        params.scriptType = 'Input';
      }
      break;
    case 'Gateway':
      params.scriptType = item.ToId;
      break;
    case 'FlowVerification':
      if (typeof item.RuleIndex === 'number') {
        params = { ...params, scriptType: item.RuleIndex };
      } else {
        let ruleSign = item.Description.match(/\[([^\]]+)/);
        if (ruleSign && ruleSign[1]) {
          params = { ...params, scriptType: btoa(ruleSign[1]) };
        }
      }
      break;
    case 'DataProvider':
      const dataSource = item.Name;
      params.scriptType = item.ScriptType === 'InputScript' ? 'Script' : item.ScriptType || params.scriptType;

      // if external DataContext
      if (item.RuntimeName || item.DataContextName) {
        params = {
          ...params,
          uri: params.uri?.replace(':runtimeName', item.RuntimeName || item.DataContextName || '') + `?scriptType=${item.ScriptType}&dataSource=${dataSource}`
        };
      } else {
        params = {
          ...params,
          itemId: 'DataContext',
          itemType: 'DataContext',
          dataSource: dataSource,
          uri: undefined,
        };
      }
      break;
    case 'Workflow':
      // open Mappings modal for SubDecision/SubProcess from item

      params = {
        ...params,
        itemId: item.ItemId || item.Name,
        itemType: 'Mapping',
        scriptType: item.ScriptType,
        uri: undefined,
      };
      break;
    case 'Signal':
      params = {
        ...params,
        itemType: 'SignalMapping',
        scriptType: 'Script',
        uri: undefined,
      };
      break;
    case 'Model':
      params = {
        ...params,
        itemType: 'ModelMapping',
        scriptType: 'Script',
        uri: undefined,
      };
      break;

    default: {}
  }

  return { target: 'self', params: params };
}

function makeLinkBlankParams(item: DependencyUsage) {
  const itemData: ItemData = items[item.ItemType];

  if (!itemData) { return null }

  itemData.params.uri = itemData.params.uri || '';

  let uri = itemData.params.uri.replace(':itemName',item.Name);

  switch (item.ItemType) {
    case 'DataProvider':
      uri = itemData.params.uri.replace(':runtimeName', item.RuntimeName || item.DataContextName || '');
      break;
    case 'Workflow':
      uri = itemData.params.uri.replace(':workflowName', item.WorkflowName || '').replace(':version', (item.WorkflowVersion || 0) + '');
      break;
    default: {}
  }

  return { target: 'blank', params: { uri } };
}
